import { BLUE_500, LILAC_100, LILAC_700, checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
var _tokens$spacing = tokens.spacing,
  SPACING_1 = _tokens$spacing.SPACING_1,
  SPACING_2 = _tokens$spacing.SPACING_2;
export var getUpsellNudgetWidgetStyles = () => {
  var flexStyle = checkIsPlatform('web') ? {} : {
    flex: 1
  };
  return StyleSheet.create({
    container: {
      borderLeftWidth: SPACING_1,
      borderRightWidth: SPACING_1,
      borderColor: LILAC_700,
      flex: 1
    },
    upsellHeaderContainer: {
      flexDirection: 'row',
      flexShrink: 0
    },
    tableScrollContainer: {
      flex: 1
    },
    upsellCellContainer: Object.assign(Object.assign({}, flexStyle), {
      flexDirection: 'row'
    }),
    upsellCellItemContainer: {
      flex: 1,
      minHeight: '100%',
      flexShrink: 1
    },
    upsellCellRowDirection: {
      flexDirection: 'row'
    }
  });
};
var commonStyle = StyleSheet.create({
  verticalBorderHighlight: {
    width: SPACING_2,
    backgroundColor: BLUE_500
  },
  verticalBorder: {
    width: SPACING_1,
    backgroundColor: LILAC_700
  },
  topBorderHighlight: {
    borderTopWidth: SPACING_2,
    borderTopColor: BLUE_500
  },
  topBorder: {
    borderTopWidth: SPACING_1,
    borderTopColor: LILAC_700
  },
  bottomBorderHighlight: {
    borderBottomWidth: SPACING_2,
    borderBottomColor: BLUE_500
  },
  bottomBorder: {
    borderBottomWidth: SPACING_1,
    borderBottomColor: LILAC_700
  },
  backgroundHighlight: {
    backgroundColor: LILAC_100
  }
});
export var getColumnSeparatorStyle = (highlight, isLastItem) => {
  var verticalBorderHighlight = commonStyle.verticalBorderHighlight,
    verticalBorder = commonStyle.verticalBorder;
  return highlight && !isLastItem ? [verticalBorderHighlight] : [verticalBorder];
};
export var getHeaderStyle = (highlight, index) => {
  var topBorderHighlight = commonStyle.topBorderHighlight,
    topBorder = commonStyle.topBorder,
    bottomBorder = commonStyle.bottomBorder;
  return highlight && index === 1 ? [topBorderHighlight, bottomBorder] : [topBorder, bottomBorder];
};
export var getCellStyle = (highlight, itemIndex, isLastRow) => {
  var bottomBorder = commonStyle.bottomBorder,
    bottomBorderHighlight = commonStyle.bottomBorderHighlight,
    backgroundHighlight = commonStyle.backgroundHighlight;
  if (highlight && itemIndex === 1 && isLastRow) {
    return [bottomBorderHighlight, backgroundHighlight];
  }
  if (highlight && itemIndex === 1) {
    return [backgroundHighlight, bottomBorder];
  }
  return [bottomBorder];
};